import { useContext, createContext } from 'react';
import { PARENT_FOCUS_KEY, ROOT_FOCUS_KEY } from '../contants';
export var FocusParentContext = createContext(PARENT_FOCUS_KEY);
export var FocusRootContext = createContext(ROOT_FOCUS_KEY);
/** @internal */
export var useFocusContext = function () { return useContext(FocusParentContext); };
export var useFocusRoot = function () { return useContext(FocusRootContext); };
